export default "__VITE_ASSET__Ch$SQ6Bk__"